export default __webpack_public_path__ + "static/media/muiRed.a15baaf3.svg";